module.exports = __webpack_public_path__ + "static/img/light_preview.66a4f10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/pic/light_preview.png
// module id = l+0M
// module chunks = 0